import { IconLink } from './types'

export const IconLinks: IconLink[] = [
	{ icon: 'icon-nzpm-flat', link: 'https://www.nzpm.co.nz/' },
	{ icon: 'icon-plumbing-world', link: 'https://www.plumbingworld.co.nz/' },
	{ icon: 'icon-metrix', link: 'https://www.metrix.co.nz/' },
]